import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { StoreModule } from '@ngrx/store';

import { PrivacyPolicyComponent } from './privacy-policy.component';
import { PrivacyPolicyBannerComponent } from './components/privacy-policy-banner/privacy-policy-banner.component';
import { PrivacyPolicySettingsComponent } from './components/privacy-policy-settings/privacy-policy-settings.component';
import { PrivacyPolicyService } from '@app/core/privacy-policy/services/privacy-policy.service';

@NgModule({
  imports: [CommonModule, StoreModule.forRoot({}), SharedModule, RouterModule],
  declarations: [PrivacyPolicyComponent, PrivacyPolicyBannerComponent, PrivacyPolicySettingsComponent],
  exports: [PrivacyPolicyComponent],
  providers: [PrivacyPolicyService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [PrivacyPolicySettingsComponent]
})
export class PrivacyPolicyModule {}
